export default (metricsHandler, errorHandler) => request => {
  const startTime = Date.now();
  const callback = request.callback;

  request.callback = (requestError, response = {}) => {
    const data = {
      duration: Date.now() - startTime,
      response,
      request
    };

    if (requestError) {
      errorHandler(requestError, requestError.message, data);
    } else {
      try {
        metricsHandler(data);
      } catch (metricsError) {
        errorHandler(metricsError, 'Error adding metrics request', data);
      }
    }

    callback.call(request, requestError, response);
  };

  return request;
};



/** WEBPACK FOOTER **
 ** ./app/wip_modules/superagent-timing/index.js
 **/